import SubmissionReceipt from './submission-receipt.html';
import controller from './submission-receipt.controller';

let SubmissionReceiptComponent = {
  restrict: 'E',
  // bindings: {
  //   timesheet: '<',
  // },
  template: SubmissionReceipt,
  controller
}

export default SubmissionReceiptComponent



// WEBPACK FOOTER //
// ./client/pages/timesheet/components/submission-receipt/submission-receipt.component.js